import React, { ChangeEvent, memo } from 'react'
import { matchSorter } from 'match-sorter'
import { Box } from 'transfix-ui/core'
import { IMotorCarrier } from 'apps/fleet-planner/types'
import { TextInput, TextInputIconType } from 'components/atoms'

// Interfaces to be updated once the swagger contract is available.
interface ICarriersListFilterProps {
  motorCarriers: IMotorCarrier[]
  onFilterChange: (filteredIds: IMotorCarrier[]) => void
}

export const CarriersListFilters = memo<ICarriersListFilterProps>(
  ({ motorCarriers, onFilterChange }) => {
    const searchFilterChangeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      onFilterChange(
        matchSorter(motorCarriers, value, {
          keys: [
            'name',
            { threshold: matchSorter.rankings.STARTS_WITH, key: 'dotNumber' },
            { threshold: matchSorter.rankings.STARTS_WITH, key: 'mcNumber' },
          ],
        })
      )
    }

    return (
      <Box maxWidth={400}>
        <TextInput
          large
          icon={TextInputIconType.search}
          placeholder='Search by carrier name, DOT, or MC number'
          onChange={searchFilterChangeHandler}
        />
      </Box>
    )
  }
)
